<template>
      <div class="moduleCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'module', params: {} }">
          Module
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'moduleCreate', params: {} }">
            Create Module
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Module</v-card-title>
          <v-card-text>
            <module-form></module-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import ModuleForm from './ModuleForm.vue';

    export default {
      name: 'module',
      components: {
        ModuleForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    